module.exports = __webpack_public_path__ + "static/media/pen.903f174e.svg";